import type { Hero, HeroStats, LevelUpInfo } from "../types";

const DELTA_LABELS: Partial<Record<keyof HeroStats, string>> = {
  power: "Power",
  armor: "Armor",
  endurance: "Endurance",
  hp: "HP",
  patk: "PATK",
  matk: "MATK",
  pdef: "PDEF",
  mdef: "MDEF",
  crit: "CRIT",
};

export function buildLevelUpInfo(before: Hero, after: Hero): LevelUpInfo | null {
  if (after.level <= before.level) return null;

  const statDeltas = {} as HeroStats;
  for (const key of Object.keys(after.stats) as (keyof HeroStats)[]) {
    statDeltas[key] = after.stats[key] - before.stats[key];
  }

  return {
    oldLevel: before.level,
    newLevel: after.level,
    levelsGained: after.level - before.level,
    skillPointsGained: after.skill_points - before.skill_points,
    statDeltas,
    newStats: after.stats,
    heroClass: after.hero_class,
  };
}

export function deltaLabel(key: keyof HeroStats, heroClass?: Hero["hero_class"]): string {
  if (key === "power" && heroClass === "MAGE") return "Intellect";
  if (key === "power") return "Power";
  return DELTA_LABELS[key] ?? key;
}
